import {ssrLazy} from 'ssr/lazy';

export const NewsHeadlineLazy = ssrLazy(() => import(/* webpackChunkName: "newsHeadline" */ '.'));
